/**
 * @module components/Table/TableHazard
 * @author Charles Blais <charles.blais@canada.ca>
 *
 * Hazard table that takes an array of site desgination objects
 */

import { Table } from 'react-bootstrap';

import { vs30toSiteDesignation } from '../../lib';

import { useLanguageState } from '../../contexts/language-state-provider';


type Props = {
  siteDesignation: SiteDesignationResponse,
  caption?: string,
  show?: string[],
}


/**
 * React component
 * ===============
 */
const TableSiteDesignation = ({
  siteDesignation,
  caption = '',
  show = [
    'sa0p2',
    'sa0p5',
    'sa1p0',
    'sa2p0',
    'sa5p0',
    'sa10p0',
    'pga',
    'pgv'
  ]
}: Props) => {
  const [ lang ] = useLanguageState();

  const site = vs30toSiteDesignation(siteDesignation.vs30)
  const printSite = <>{site.charAt(0)}<sub>{site.substring(1)}</sub></>

  const keyTranform: {[key: string]: string | JSX.Element} = {
    siteDesignation: lang.table.siteDesignation,
    poe50: lang.table.poe50,
    sa0p05: <>S<sub>a</sub>(0.05, {printSite})</>,
    sa0p1: <>S<sub>a</sub>(0.1, {printSite})</>,
    sa0p2: <>S<sub>a</sub>(0.2, {printSite})</>,
    sa0p3: <>S<sub>a</sub>(0.3, {printSite})</>,
    sa0p5: <>S<sub>a</sub>(0.5, {printSite})</>,
    sa1p0: <>S<sub>a</sub>(1.0, {printSite})</>,
    sa2p0: <>S<sub>a</sub>(2.0, {printSite})</>,
    sa5p0: <>S<sub>a</sub>(5.0, {printSite})</>,
    sa10p0: <>S<sub>a</sub>(10.0, {printSite})</>,
    pga: <>PGA({printSite})</>,
    pgv: <>PGV({printSite})</>,
  }

  const headers = show.map(key => {
    if( key in keyTranform )
    {
      return (<th key={key}>{keyTranform[key]}</th>)
    }
    return null;
  });

  const body = show.map(key => {
    // @ts-ignore: we know the key exist since we check, ignore error
    const value = ( key === 'siteDesignation' ) ? printSite : siteDesignation[key];
    return (
      <td key={key}>{value}</td>
    )
  });

  return (
    <Table className='site-designation'>
      <caption>{ caption }</caption>
      <thead>
        <tr>
          { headers }
        </tr>
      </thead>
      <tbody>
        <tr>
          { body }
        </tr>
      </tbody>
    </Table>
  )
};


export default TableSiteDesignation;